import React, {
  useContext,
  useState,
  useRef,
  useEffect,
  useCallback,
} from "react";
import CloseIcon from "@mui/icons-material/Close";
import HeadBar from "../headBar/HeadBar";
import PageHeader from "../../pageheader/PageHeader";
import stepColor1 from "../../../asset/icon/stepColor1.svg";
import stepColor2 from "../../../asset/icon/stepColor2.svg";
import stepColor4 from "../../../asset/icon/stepColor4.svg";
import $style from "../../smartcard/SmartCard.module.css";
import ToggleCheckbox from "../../material/toggleCheckbox/ToggleCheckbox";
import { generateID } from "../../../utils/utils";
import Footer from "../footer/Footer";
import ComboBox from "../../combobox/ComboBox";
import ComboBoxV2 from "../../combobox/ComboBoxV2";
import {
  getDataDoctorList,
  getDataDoctorListAll,
  postRequestPermissionHospitalTeam,
  postRequestPermissionDoctor,
  postPatientSearch,
} from "../../../service/medicalApi";
import { useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../../App";
import Input from "../../material/input/Input";
import { useLocation } from "react-router-dom";
import { isAfter } from "date-fns";

function IDcardRequestData({ disabledMenu }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [cidElementID] = useState(`card-id-${generateID()}`);
  const [titlePage, setTitlePage] = useState("กรุณาเสียบบัตรประชาชน");
  const { setIsMessage } = useContext(CurrentUserContext);
  const [personalData, setPersonalData] = useState("");
  const [doctorLists, setDoctorLists] = useState([]);
  const [allDoctorLists, setAllDoctorLists] = useState([]);
  const [doctorRequest, setDoctorRequest] = useState(
    (location?.state && location?.state?.doctor) ||
      JSON.parse(localStorage.getItem("user")).uid ||
      null,
  );
  const [open, setOpen] = useState(0);
  const startScanCard = useRef(false);
  const [scaningCardStatus, setScaningCardStatus] = useState(false);
  const [personalImage, setPersonalImage] = useState(null);
  const [permissionState, setPermissionState] = useState("day");
  const [startScanCardStatus, setStartScanCardStatus] = useState(false);

  const hospitalPersonal = JSON.parse(localStorage.getItem("user"));

  const getDoctorList = useCallback(async () => {
    let data = {
      hospital_id: hospitalPersonal?.hospital?.hospital_id,
    };
    await getDataDoctorList(data).then((res) => {
      if (res.status === 200) {
        const lists = (res.data.doctor_list ?? []).map((data, index) => {
          return {
            ...data,
            fullName: `${data.fname} ${data.lname}`,
          };
        });
        setDoctorLists(lists);
      }
    });
  }, []);

  const getAllDoctorList = useCallback(async () => {
    await getDataDoctorList().then((res) => {
      if (res.status === 200) {
        const lists = (res.data.doctor_list ?? []).map((data, index) => {
          return {
            ...data,
            fullName: `${data.fname} ${data.lname}`,
          };
        });
        setAllDoctorLists(lists);
      }
    });
  }, []);

  useEffect(() => {
    getDoctorList();
    getAllDoctorList();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (location?.state && location?.state?.doctor) {
      setOpen(1);
    }

    if (
      !hospitalPersonal?.auth?.role?.includes("HOSPITAL_PERSONNEL") &&
      !hospitalPersonal?.auth?.role?.includes("MEDICAL_PERSONNEL")
    ) {
      navigate("/");
    }
  }, [getDoctorList, getAllDoctorList]);

  const requestPermission = useCallback(async () => {
    const personalDataCID = personalData.replace(/-/g, "");

    try {
      const user = JSON.parse(localStorage.getItem("user"));
      const isDoctor = user?.auth?.role?.includes("MEDICAL_PERSONNEL");

      if (personalDataCID.length === 0) {
        setIsMessage({ type: "warning", data: 'กรุณาเเสกนบัตรประชาชน'  });
        return
      }

      if (doctorRequest.length === 0) {
        setIsMessage({ type: "warning", data: 'กรุณาเลือกแพทย์หรือเภสัชกร' });
        return
      }

      const apiCall = isDoctor
        ? postRequestPermissionDoctor(personalDataCID, permissionState)
        : postRequestPermissionHospitalTeam(
            doctorRequest,
            personalDataCID,
            permissionState,
          );

      const res = await apiCall;
      if (res?.status === 200){
        if (res?.data?.code === 200){
          setIsMessage({ type: "success", data: res.data.message });
          navigate("/search-for-patient-information");
        } else {
          setIsMessage({ type: "warning", data: res.data.message_th || res.data.message, });
        }
      } else {
        setIsMessage({
          type: "error",
          data: 'กรุณาเเจ้งเจ้าหน้าที่',
        });
      }
    } catch (error) {
      console.error("Navigation error:", error);
      setIsMessage({
        type: "error",
        data: error.message || "Something went wrong",
      });
    }
  }, [setIsMessage, personalData, permissionState, doctorRequest, navigate]);

  const dataSteps = [
    {
      icon: stepColor1,
      title: "เจ้าหน้าที่เสียบบัตรประชาชนที่จุดรับบริการ",
    },
    {
      icon: stepColor2,
      title:
        "เจ้าหน้าที่กรอกหมายเลขโทรศัพท์ผู้ยินยอมสิทธิ์สำหรับการยืนยันตัวตนด้วยรหัส OTP",
    },
    {
      icon: stepColor4,
      title: "เจ้าหน้าที่กดอนุญาต/ไม่อนุญาตสิทธิ์การเข้าถึงข้อมูล",
    },
  ];

  const smartCardData = useRef([]);
  const smartCardDataList = useRef({
    key: "",
    CID: "",
    fullName: "",
  });
  const getPersonalData = useRef(true);
  const currrentPersonalData = useRef();

  const handlerPermissionState = (e) => {
    setPermissionState(e.target.value);
  };

  const handlerSelectDoctor = (e) => {
    setDoctorRequest(e.$value);
  };

  const clearPersonalData = () => {
    setPersonalData("");
    setTitlePage("กรุณาเสียบบัตรประชาชน");
    setPersonalImage("");
    setOpen(0);
  };

  const handlergetPersonalData = useCallback(
    async (data) => {
      const cleanCID = data.CID.replace(/[-\s]/g, "");

      try {
        // เรียก API เพียงครั้งเดียวที่ต้นฟังก์ชัน
        const response = await postPatientSearch(cleanCID, data.fullName);
        const patientData = response.data;

        setPersonalData(data.CID);

        if (patientData.code === 200) {
          // ตรวจสอบเงื่อนไขจาก location state ภายหลัง
          if (
            location?.state?.id_card &&
            cleanCID !== location?.state?.id_card
          ) {
            // 处理 logic กรณี ID ไม่ตรง (ถ้าจำเป็น)
          }
          setOpen(1);
        } else if (patientData.code === 204) {
          setOpen(1);
          setIsMessage({
            type: "warning",
            data: patientData.message_th || patientData.message,
          });
        }  else {
          setOpen(0);
          setIsMessage({
            type: "warning",
            data: "กรุณาลงทะเบียนในระบบผูกพันธ์",
          });
        }
      } catch (error) {
        setIsMessage({ type: "error", data: "เกิดข้อผิดพลาดในการเชื่อมต่อ" });
      }
    },
    [location, setIsMessage],
  );

  // const handlergetPersonalData = useCallback(
  //   async (data) => {
  //     if (location?.state?.id_card) {
  //       if (data.CID.replace(/[-\s]/g, "") == location?.state?.id_card) {
  //         const patient = await postPatientSearch(
  //           data.CID.replace(/[-\s]/g, ""),
  //           data.fullName,
  //         );
  //         if (patient["data"]["code"] === 200) {
  //           if (!location?.state && !location?.state?.doctor) {
  //             setPersonalData(data.CID);
  //             setOpen(1);
  //           }
  //         } else if (patient["data"]["code"] === 204) {
  //           setPersonalData(data.CID);
  //           setOpen(0);
  //           setIsMessage({
  //             type: "warning",
  //             data: "กรุณาลงทะเบียนในระบบผูกพันธ์",
  //           });
  //         } else {
  //           setPersonalData(data.CID);
  //           setOpen(0);
  //           setIsMessage({
  //             type: "warning",
  //             data: "กรุณาลงทะเบียนในระบบผูกพันธ์",
  //           });
  //         }
  //       } else {
  //         const patient = await postPatientSearch(
  //           data.CID.replace(/[-\s]/g, ""),
  //           data.fullName,
  //         );
  //         if (patient["data"]["code"] === 200) {
  //           if (!location?.state && !location?.state?.doctor) {
  //             setPersonalData(data.CID);
  //             setOpen(1);
  //           }
  //         } else if (patient["data"]["code"] === 204) {
  //           setPersonalData(data.CID);
  //           setIsMessage({
  //             type: "warning",
  //             data: "กรุณาลงทะเบียนในระบบผูกพันธ์",
  //           });
  //           setOpen(0);
  //         } else {
  //           setPersonalData(data.CID);
  //           setIsMessage({
  //             type: "warning",
  //             data: "กรุณาลงทะเบียนในระบบผูกพันธ์",
  //           });
  //           setOpen(0);
  //         }
  //       }
  //     } else {
  //       const patient = await postPatientSearch(
  //         data.CID.replace(/[-\s]/g, ""),
  //         data.fullName,
  //       );
  //       if (patient["data"]["code"] === 200) {
  //         setPersonalData(data.CID);
  //         setOpen(1);
  //       } else if (patient["data"]["code"] === 204) {
  //         setPersonalData(data.CID);
  //         setIsMessage({
  //           type: "warning",
  //           data: "กรุณาลงทะเบียนในระบบผูกพันธ์",
  //         });
  //         setOpen(0);
  //       } else {
  //         setPersonalData(data.CID);
  //         setIsMessage({
  //           type: "warning",
  //           data: "กรุณาลงทะเบียนในระบบผูกพันธ์",
  //         });
  //         setOpen(0);
  //       }
  //     }
  //   },
  //   [location],
  // );

  const formatThaiID = useCallback(
    (CID) => {
      const cleanID = CID.replace(/[-\s]/g, "");
      if (cleanID.length !== 13) {
        setIsMessage({ type: "error", data: "เลขบัตรประชาชนไม่ถูกต้อง" });
        setOpen(0);
        return null;
      }
      const cleanWord = ("" + cleanID).replace(/\D/g, "");
      const match = cleanWord.match(/^(\d{1})(\d{4})(\d{5})(\d{2})(\d{1})$/);
      if (match) {
        return match
          .filter((data, index) => [1, 2, 3, 4, 5].includes(index))
          .join("-");
      }
      setIsMessage({ type: "error", data: "เลขบัตรประชาชนไม่ถูกต้อง" });
      setOpen(0);
      return null;
    },
    [setIsMessage],
  );

  useEffect(() => {
    const setSmartCardDataKey = async () => {
      return new Promise((resolve, reject) => {
        currrentPersonalData.current = setTimeout(() => {
          getPersonalData.current = false;
          if (smartCardData.current.length === 3) {
            smartCardDataList.current.key = smartCardData.current[0];
            smartCardDataList.current.CID = smartCardData.current[1];
            smartCardDataList.current.fullName = smartCardData.current[2];
            resolve(true);
          } else {
            reject(false);
          }
        }, 1000);
      });
    };

    const emitPersonalData = () => {
      let checkKey;
      let clearCheckKey = 0;
      checkKey = setInterval(() => {
        if (clearCheckKey >= 2000) {
          clearInterval(checkKey);
        }
        if (smartCardDataList.current.key !== "") {
          if (
            smartCardDataList.current.key ===
            process.env.REACT_APP_SMARTCARD_KEY
          ) {
            const CID = formatThaiID(smartCardDataList.current.CID);
            if (CID !== null) {
              handlergetPersonalData({
                CID: CID,
                fullName: smartCardDataList.current.fullName,
              });
              setTitlePage(smartCardDataList.current.fullName);
            } else {
              setTitlePage("กรุณาเสียบบัตรประชาชน");
            }
            startScanCard.current = false;
            setStartScanCardStatus(false);
            setScaningCardStatus(false);
          } else {
            setIsMessage({ type: "error", data: "Error Key Access Failed" });
            startScanCard.current = false;
            setStartScanCardStatus(false);
            setScaningCardStatus(false);
            setTitlePage("กรุณาเสียบบัตรประชาชน");
            console.error("Error Key Access Failed");
          }
          smartCardData.current = [];
          clearInterval(checkKey);
        }
        clearCheckKey += 500;
      }, 500);
    };

    document.addEventListener("paste", async (e) => {
      clearTimeout(currrentPersonalData.current);
      if (!startScanCard.current) {
        return;
      }

      if (!getPersonalData.current) {
        smartCardData.current = [];
      }

      getPersonalData.current = true;
      /**
       * @param textData เก็บข้อมูลที่เป็นตัวอักษรเช่น ตัวเลข ชื่อ วันที่
       */
      const textData = e.clipboardData.getData("text");
      let personImgSrc = "";
      if (textData !== "") {
        smartCardData.current.push(textData);
      } else {
        for (const clipboardItem of e.clipboardData?.files) {
          if (clipboardItem.type.startsWith("image/")) {
            /**
             * @param file เก็บข้อมูลที่เป็นรูปภาพแล้วแปลงเป็น Blob Object
             */
            personImgSrc = URL.createObjectURL(clipboardItem);
            if (personImgSrc !== "") {
              setPersonalImage(personImgSrc);
            }
          }
        }
      }
      currrentPersonalData.current = setTimeout(() => {
        getPersonalData.current = false;
      }, 1000);
      if (smartCardData.current.length === 3) {
        setScaningCardStatus(true);
        setTitlePage("กำลังแสกนบัตร...");
        navigator.clipboard.writeText("");
        await setSmartCardDataKey().then(() => {
          emitPersonalData();
        });
      }
    });
  }, [handlergetPersonalData, setIsMessage, formatThaiID]);

  const toggleStart = (value) => {
    document.activeElement.blur();
    document.body.focus();
    setStartScanCardStatus(value);
    startScanCard.current = value;
    if (!value) {
      setTitlePage("กรุณาเสียบบัตรประชาชน");
    }
  };

  return (
    <>
      <div className="global-page md:mt-[30px]">
        <span className="text-[red] text-[1.2rem] mt-10">
          กรุณาใช้งานผ่าน Google Chrome
        </span>
        <PageHeader titlename="สิทธิ์การเข้าถึงข้อมูลด้วยบัตรประชาชน (ID Card)" />
        <div>
          <span>ขั้นตอนการขอสิทธิ์การเข้าถึงข้อมูลด้วยบัตรประชาชน</span>
          <ul>
            <li>1. เจ้าหน้าที่เสียบบัตรประชาชนที่จุดรับบริการ</li>
            <li>
              2. เจ้าหน้าที่กรอกหมายเลขโทรศัพท์
              ผู้ยินยอมสิทธิ์สําหรับการยืนยันตัวตนด้วยรหัส OTP
            </li>
            <li>3. ผู้ยินยอมแจ้งรหัส OTP ต่อเจ้าหน้าที่</li>
            <li>4. เจ้าหน้าที่กดอนุญาติ/ไม่อนุญาติสิทธิ์การเข้าถึงข้อมูล</li>
          </ul>
        </div>
        <div className="grid md:grid-cols-1 grid-cols-3 gap-10 my-10">
          {dataSteps.map((item, index) => (
            <div key={index} className="flex flex-col gap-4">
              <div className="flex justify-center">
                <img src={item.icon} alt="Icon Step" />
              </div>
              <span className="w-full text-center text-[18px]">
                {index + 1}. {item.title}
              </span>
            </div>
          ))}
        </div>
        <div className="w-full flex justify-center">
          <div className="flex flex-col justify-center items-center w-[min(500px,100%)]">
            {personalImage !== null && personalData !== "" ? (
              <>
                <div className="w-[148px] h-[178px] pointer-events-none select-none">
                  <img
                    src={personalImage}
                    alt="smart card"
                    draggable={false}
                    className="w-full h-full object-contain object-center pointer-events-none select-none"
                  />
                </div>
              </>
            ) : (
              <>
                <div className="w-[min(250px,95vw)] flex flex-col items-center justify-center mb-4">
                  <div className="relative w-full flex items-end justify-end min-h-[50px] py-4 z-0 bg-[#444] border border-[#444]">
                    <div
                      className={
                        scaningCardStatus
                          ? "pointer-events-none select-none opacity-50"
                          : ""
                      }
                    >
                      <ToggleCheckbox
                        value={startScanCardStatus}
                        setValue={toggleStart}
                        onOff
                      />
                    </div>
                  </div>
                  <div className="relative h-[160px] w-full overflow-hidden z-20">
                    <span className="absolute w-[min(150px,90%)] left-1/2 -translate-x-1/2 top-0 border-x-2 border-t-4 border-black h-3.5 border-b-0 rounded-t-full z-20"></span>
                    <div className="absolute w-full left-1/2 -translate-x-1/2 top-0 h-1/5 bg-[#444] rounded-b-2xl"></div>
                    <div
                      className={
                        startScanCardStatus
                          ? scaningCardStatus
                            ? $style.smartcard_insert_scan
                            : $style.smartcard_insert_start
                          : $style.smartcard_insert
                      }
                    >
                      <div className="rotate-90 origin-center transition-transform z-10">
                        <span className="sm:text-[5rem] md:text-[7.5rem] text-[10rem]">
                          <svg
                            width="1em"
                            height="0.643em"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 28 18"
                          >
                            {" "}
                            <path
                              d="M 25.8 18 L 2.2 18 C 1 18 0 17 0 15.8 L 0 2.2 C 0 1 1 0 2.2 0 L 25.7 0 C 27 0 28 1 28 2.2 L 28 15.7 C 28 17 27 18 25.8 18 Z"
                              fill="#26C9FC"
                            ></path>{" "}
                            <path
                              d="M 24.404 16 L 12.595 16 C 12.297 16 12 15.807 12 15.42 L 12 13.581 C 12 13.291 12.198 13 12.595 13 L 24.404 13 C 24.702 13 25 13.194 25 13.581 L 25 15.42 C 25 15.71 24.702 16 24.404 16 Z"
                              fill="#F4F4F4"
                            ></path>{" "}
                            <path
                              d="M 9.024 11 L 6 11 L 2.975 11 C 2.583 11 2.191 11.742 2.052 11.329 C 2.018 11.228 2 11.118 2 11 L 2 3 C 2 2.5 2.39 2 2.975 2 L 9.024 2 C 9.512 2 10 2.4 10 3 L 10 11 C 10 11.073 9.994 11.142 9.983 11.208 C 9.903 11.691 9.539 11 9.024 11 Z"
                              fill="white"
                            ></path>{" "}
                            <path
                              d="M 12.5 3 C 12.224 3 12 3.224 12 3.5 C 12 3.776 12.224 4 12.5 4 L 24.5 4 C 24.776 4 25 3.776 25 3.5 C 25 3.224 24.776 3 24.5 3 L 12.5 3 Z M 12 6.5 C 12 6.224 12.224 6 12.5 6 L 24.5 6 C 24.776 6 25 6.224 25 6.5 C 25 6.776 24.776 7 24.5 7 L 12.5 7 C 12.224 7 12 6.776 12 6.5 Z M 12 9.5 C 12 9.224 12.224 9 12.5 9 L 24.5 9 C 24.776 9 25 9.224 25 9.5 C 25 9.776 24.776 10 24.5 10 L 12.5 10 C 12.224 10 12 9.776 12 9.5 Z"
                              fill="#0074BA"
                            ></path>{" "}
                            <path
                              d="M 6.475 3 L 5.496 3 C 4.419 3 3.636 3.921 3.734 5.046 L 3.775 5.576 C 3.471 5.649 3.244 5.933 3.244 6.273 C 3.244 6.652 3.526 6.962 3.883 6.987 L 3.93 7.603 C 4.007 8.246 4.447 8.826 5.059 9.044 C 3.786 9.328 2.695 10.128 2 11.225 C 2.11 11.699 2.53 12 2.951 12 L 9.021 12 C 9.608 12 10 11.591 10 10.978 C 9.282 9.98 8.224 9.265 7.005 9.023 C 7.569 8.805 7.969 8.289 8.042 7.603 L 8.089 6.987 C 8.445 6.962 8.727 6.652 8.727 6.273 C 8.727 5.933 8.501 5.649 8.197 5.576 L 8.237 5.046 C 8.335 3.921 7.454 3 6.475 3 Z"
                              fill="#321B41"
                            ></path>{" "}
                            <path
                              d="M 13.5 15 L 23.5 15 C 23.7 15 24 14.8 24 14.5 C 24 14.2 23.8 14 23.5 14 L 13.5 14 C 13.2 14 13 14.2 13 14.5 C 13 14.8 13.2 15 13.5 15 Z"
                              fill="#321B41"
                            ></path>{" "}
                          </svg>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div className="flex flex-col w-full">
              <span className="text-[30px] font-bold pointer-events-none select-none">
                {titlePage}
              </span>

              <div className="my-2">
                <Input
                  type="text"
                  id={cidElementID}
                  classNameLabel="text-[1rem]"
                  label="เลขบัตรประจำตัวประชาชนผู้ยินยอมสิทธิ์เข้าถึงข้อมูล"
                  placeholder="กรอกเลขบัตรประจำตัวประชาชน 13 หลัก"
                  value={personalData}
                  icon={
                    personalData && (
                      <>
                        <CloseIcon sx={{ fontSize: 16 }} />
                      </>
                    )
                  }
                  onChangeEvt={(e) => setPersonalData(e.target.value)}
                  onIconClick={(e) => clearPersonalData()}
                  disabled
                  readOnly
                />
              </div>
              {open === 1 ? (
                <>
                  {!hospitalPersonal?.auth?.role?.includes(
                    "MEDICAL_PERSONNEL",
                  ) && (
                    <>
                      {!(location?.state && location?.state?.doctor) && (
                        <div className="my-2">
                          <label className="text-[1rem]">
                            แพทย์/เภสัชกรที่ขอสิทธิ์เข้าถึงข้อมูล
                          </label>
                          {/* <ComboBox
                            itemsLists={doctorLists}
                            index="uid"
                            option="fullName"
                            placeholder="เลือกแพทย์"
                            searchPlaceholder="กรอกชื่อแพทย์"
                            onChange={(e) => {
                              handlerSelectDoctor(e);
                            }}
                          /> */}
                          <ComboBoxV2
                            itemsLists={doctorLists}
                            itemsAll={allDoctorLists}
                            index="uid"
                            option="fullName"
                            placeholder="เลือกแพทย์"
                            searchPlaceholder="กรอกชื่อแพทย์"
                            onChange={(e) => {
                              handlerSelectDoctor(e);
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}

                  <div className="my-2">
                    <label className="w-full inline-flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        id="permission-status-forever"
                        value="forever"
                        name="permission-status"
                        className="sr-only peer"
                        checked={permissionState === "forever"}
                        onChange={(e) => handlerPermissionState(e)}
                      />
                      <div className="relative w-5 aspect-square flex items-center justify-center rounded-full border border-gray-500 overflow-hidden peer-checked:bg-green-500 after:hidden peer-checked:after:block after:absolute after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:bg-white after:w-1/2 after:aspect-square after:rounded-full"></div>
                      <span className="inline-block w-[calc(100%-1.25rem)]">
                        ยินยอมให้แพทย์และเภสัชกรเข้าถึงข้อมูลผลตรวจได้ตลอดเพื่อเป็น
                        ประโยชน์ในการป้องกันและรักษาโรค จนกว่าจะยกเลิกการอนุญาต
                      </span>
                    </label>
                  </div>

                  <div className="mt-2 mb-4">
                    <label className="w-full inline-flex items-center gap-2 cursor-pointer">
                      <input
                        type="radio"
                        id="permission-status-day"
                        value="day"
                        name="permission-status"
                        className="sr-only peer"
                        checked={permissionState === "day"}
                        onChange={(e) => handlerPermissionState(e)}
                      />
                      <div className="relative w-5 aspect-square flex items-center justify-center rounded-full border border-gray-500 overflow-hidden peer-checked:bg-green-500 after:hidden peer-checked:after:block after:absolute after:top-1/2 after:left-1/2 after:-translate-x-1/2 after:-translate-y-1/2 after:bg-white after:w-1/2 after:aspect-square after:rounded-full"></div>
                      <span className="inline-block w-[calc(100%-1.25rem)]">
                        อนุญาตให้แพทย์หรือเภสัชกรท่านนี้ เข้าถึงข้อมูลได้ภายใน
                        24 ชั่วโมง
                      </span>
                    </label>
                  </div>
                  <div className="w-full flex flex-row md:flex-col justify-center items-center mb-4 gap-[10px]">
                    <button
                      onClick={() => {
                        clearPersonalData();
                      }}
                      className="bg-white w-full text-bold text-center rounded-md py-3 text-black border"
                    >
                      ยกเลิก
                    </button>
                    <button
                      onClick={() => {
                        requestPermission();
                      }}
                      className="bg-[#42A1EF] w-full text-center rounded-md py-3 text-[#ffffff]"
                    >
                      อนุมัติ
                    </button>
                  </div>
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IDcardRequestData;
